/** Typed API error structure matching Axios error responses */
export interface ApiError {
  response?: {
    data?: {
      error?: string
      message?: string
    }
    status?: number
  }
  message?: string
}

/** Type guard for API errors */
export function isApiError(err: Error | ApiError): err is ApiError {
  return 'response' in err || 'message' in err
}

/** Extract a human-readable error message from an API error */
export function getErrorMessage(err: Error | ApiError, fallback = 'An unexpected error occurred'): string {
  if (isApiError(err)) {
    return err.response?.data?.error
      || err.response?.data?.message
      || err.message
      || fallback
  }
  if (err instanceof Error) {
    return err.message || fallback
  }
  return fallback
}
